window.datepicker = function() {
    $(".datepicker").flatpickr({
        allowInput: true,
        dateFormat: window.datepicker_format ? window.datepicker_format : "d-m-Y",
        locale: flatpickrLanguageSwitch(window.locale || "en"),
        weekNumbers: true,
    });
};
